export default "__VITE_ASSET__CWVkjXjm__"